import Router, { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { HOME_PATHNAME, SIGNIN_PATHNAME } from '@glass/common/modules/pages/paths';
import { FAIL_QUERY } from '@glass/common/modules/pages/queryParams';
import { selectIsUser } from '@glass/web/modules/auth';
import selectIsAuthReady from '@glass/web/modules/userConfig/selectors/selectIsAuthReady';

import { SIGNIN_ACTION } from '@glass/shared/modules/auth/authActionTypes';
import ensureUserAction from '@glass/shared/modules/authForm/actions/ensureUserAction';

const DEFAULT_FAIL_PATH =
  process.env.NEXT_PUBLIC_BRAND === 'rock' ? HOME_PATHNAME : SIGNIN_PATHNAME;

const useRequireAuth = ({ shouldPrompt = true } = {}) => {
  const {
    isReady,
    query: { [FAIL_QUERY]: failPathname = DEFAULT_FAIL_PATH },
  } = useRouter();

  const handleAuthFail = useCallback(() => Router.replace(failPathname), [failPathname]);
  const isUser = useSelector(selectIsUser);
  const authReady = useSelector(selectIsAuthReady);
  const dispatch = useDispatch();
  const [prompted, setPrompted] = useState(false);

  const ready = isReady && authReady;
  const readyToPrompt = ready && !isUser && shouldPrompt && !prompted;

  useEffect(() => {
    if (readyToPrompt) {
      setPrompted(true);
      dispatch(
        ensureUserAction({
          next: false,
          actionType: SIGNIN_ACTION,
          availableActions: [SIGNIN_ACTION],
        }),
      ).catch(handleAuthFail);
    }
  }, [readyToPrompt, handleAuthFail, dispatch]);

  return {
    loading: !ready,
    isUser,
  };
};

export default useRequireAuth;
